import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const createQuestionAnswerAction = createAsyncThunk(
    'create-question-answer',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/support-server/api/create-question-answer`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createQuestionAnswerSlice = createSlice({
    name: 'create-question-answer',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createQuestionAnswerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createQuestionAnswerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createQuestionAnswerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createQuestionAnswerReducer = createQuestionAnswerSlice.reducer